import React, { useContext, useState } from "react";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Box,
  Autocomplete,
  Button,
  FormControl,
  MenuItem,
  FormLabel,
  Typography,
  Fab,
  IconButton,
  Tooltip,
  Divider,
  OutlinedInput,
  InputAdornment,
  Alert,
  useTheme,
  Dialog,
  Snackbar,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import {
  col,
  formGroupContainer,
  groupStyled,
  header,
  labelStyled,
  leftCol,
  row,
} from "../../../components/300/styles";
import { array } from "yup/lib/locale";
import { useEffect } from "react";
import CustomizedSnackbars from "../../300/curriculum/CustomizedSnackbars";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import ImportModal from "./ImportModal";

import CourseContext from "../../../context/CourseContext";
import OfficeContext from "../../../context/OfficeContext";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

let curriculumData = [
  { id: 1, name: "Curiculum101" },
  { id: 2, name: "Curiculum102" },
  { id: 3, name: "Curiculum103" },
];
const semester = [
  { name: "I", value: 1 },
  { name: "II", value: 2 },
];
const year = [
  { name: "1", value: 1 },
  { name: "2", value: 2 },
  { name: "3", value: 3 },
  { name: "4", value: 4 },
  { name: "5", value: 5 },
];
const owner = [
  { name: "Software Department", value: "software_engineering_dep" },
  { name: "Electrical Department", value: "electrical_engineering_dep" },
  { name: "Mechanical Department", value: "mechanical_engineering_dep" },
  { name: "Civil Department", value: "civil_engineering_dep" },
];

function EditCourse() {
  const api = useAxiosPrivate();
  const courseContext = useContext(CourseContext);
  const officeContext = useContext(OfficeContext);
  const location = useLocation();
  const navigate = useNavigate();

  let course = courseContext.courseState.filter((course) => {
    return course.course_code === location.state.id;
  })[0];
  //  useEffect(() => {}, [id]);
  let GlobalcurriculumState = {
    id: { value: "", required: true },
    year: { value: "", required: true },
    semester_term: { value: "", required: true },
  };
  console.log(course);
  let CurriculumValues = course.curriculums.map((c) => {
    return {
      id: { value: c.name, required: true },
      year: { value: c.year, required: true },
      semester_term: { value: c.semester_term, required: true },
      relation_id: c.relation_id,
    };
  });
  console.log(CurriculumValues);

  let GlobalcurriculumBlurState = {
    id: false,
    year: false,
    semester_term: false,
  };
  let CurriculumBlur = course.curriculums.map((c) => {
    return GlobalcurriculumBlurState;
  });
  let GlobalcurriculumErrorState = {
    id: false,
    year: false,
    semester_term: false,
  };
  let CurriculumError = course.curriculums.map((c) => {
    return GlobalcurriculumErrorState;
  });

  let staticFields = {
    course_name: { value: course.course_name, required: true },
    course_code: { value: course.course_code, required: true },
    credit_hr: { value: course.credit_hr, required: true },
    owner: { value: course.owner.id, required: true },
    lecture: { value: course.lecture, required: false },
    lab: { value: course.lab, required: false },
    tutorial: { value: course.tutorial, required: false },

    mentoring: { value: course.mentoring, required: false },
    advisory: { value: course.advisory, required: false },
  };

  let schema = {
    ...staticFields,
    curriculums: CurriculumValues,
    blurred: {
      course_name: false,
      curriculums: [...CurriculumBlur],
    },
    errors: {
      course_name: false,
      course_code: false,
      credit_hr: false,
      lecture: false,
      lab: false,
      tutorial: false,
      mentoring: false,
      advisory: false,
      owner: false,
      curriculums: [...CurriculumError],
    },
    isSubmitted: false,
  };
  const [form, setForm] = useState(schema);
  const [open, setOpen] = useState(false);
  const [errorExists, setErrorExists] = useState({
    fieldError: false,
    hourError: false,
    additionError: false,
  });
  const [snackBarOpen, setSnackBarOpen] = React.useState(true);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });

  const [addedN, setAddedN] = useState(0);

  const theme = useTheme();
  //handlers
  const handleChange = (e, index, name, newValue) => {
    e.preventDefault();
    let key = e.target.name;
    // for the values in the curriculum array
    if (index >= 0) {
      setForm((prev) => {
        let curriculums = prev.curriculums.map((data, i) => {
          if (i !== index) {
            return data;
          }
          if (name) {
            return {
              ...data,
              id: { ...data.id, value: newValue },
            };
          } else {
            return {
              ...data,
              [e.target.name]: {
                ...data[e.target.name],
                value: e.target.value,
              },
            };
          }
        });
        let errorCurriculms = prev.errors.curriculums.map((data, i) => {
          if (i !== index) {
            return data;
          }
          if (name) {
            return { ...data, id: !Boolean(newValue) };
          } else {
            return {
              ...data,
              [e.target.name]: !Boolean(e.target.value),
            };
          }
        });
        let errors = { ...form.errors, curriculums: errorCurriculms };
        return {
          ...prev,
          curriculums: curriculums,
          errors: errors,
        };
      });
    } else {
      let errors = {
        ...form.errors,
        [e.target.name]: !Boolean(e.target.value),
      };
      let newForm = {
        ...form,
        [e.target.name]: { ...form[e.target.name], value: e.target.value },
        errors: errors,
      };
      setForm(newForm);
    }
  };
  const handleBlur = (e, index, name) => {
    e.preventDefault();

    // for the values in the blurred.curriculums array
    if (index >= 0) {
      setForm((prev) => {
        let blurredCurriculums = prev.blurred.curriculums.map((data, i) => {
          if (i !== index) {
            return data;
          }
          if (name) {
            return {
              ...data,
              id: true,
            };
          } else {
            return {
              ...data,
              [e.target.name]: true,
            };
          }
        });
        let newBlurred = { ...prev.blurred, curriculums: blurredCurriculums };
        return { ...prev, blurred: newBlurred };
      });
    } else {
      setForm((prev) => {
        let newBlurred = { ...prev.blurred, [e.target.name]: true };
        return { ...prev, blurred: newBlurred };
      });
    }
  };
  const checkError = () => {
    //checks if there is an error in the fields
    let curriculumError = form.errors.curriculums.reduce((total, current) => {
      return total || current.id || current.semester_term || current.year;
    }, false);

    let staticFieldsError =
      form.errors.course_name ||
      form.errors.course_code ||
      form.errors.owner ||
      form.errors.credit_hr;
    let totalError = curriculumError || staticFieldsError;

    let hourError =
      form.errors.lecture &&
      form.errors.lab &&
      form.errors.tutorial &&
      form.errors.mentoring &&
      form.errors.advisory;

    let found = courseContext.curriculumState.filter((cur) => {
      console.log("searching", cur);
      console.log("already added", form.curriculums[0]);
      return cur.name == form.curriculums[0].id.value;
    })[0];

    let added =
      (parseInt(form.lecture?.value) *
        parseInt(
          courseContext.hoursState[
            `lecture_${found?.program_type.toLowerCase()}_hourSetting`
          ]
        ) || 0) +
      (parseInt(form.lab?.value) *
        parseInt(
          courseContext.hoursState[
            `lab_${found?.program_type.toLowerCase()}_hourSetting`
          ]
        ) || 0) +
      (parseInt(form.advisory?.value) *
        parseInt(
          courseContext.hoursState[
            `advisory_${found?.program_type.toLowerCase()}_hourSetting`
          ]
        ) || 0) +
      (parseInt(form.mentoring?.value) *
        parseInt(
          courseContext.hoursState[
            `mentoring_${found?.program_type.toLowerCase()}_hourSetting`
          ]
        ) || 0) +
      (parseInt(form.tutorial?.value) *
        parseInt(
          courseContext.hoursState[
            `tutorial_${found?.program_type.toLowerCase()}_hourSetting`
          ]
        ) || 0);
    setAddedN(added);
    //alert(JSON.stringify(found, null, 2));

    let thereIsError = form.credit_hr.value != added;

    setErrorExists((prev) => {
      return {
        ...prev,
        fieldError: totalError,
        hourError: hourError,
        additionError: thereIsError,
      };
    });
  };
  const handleAddCurriculum = (e) => {
    console.log("here");
    e.preventDefault();
    // for handling data state

    let curriculums = [...form.curriculums, GlobalcurriculumState];

    // for handling blur state
    let blurredCurriculms = [
      ...form.blurred.curriculums,
      GlobalcurriculumBlurState,
    ];
    let newBlurred = { ...form.blurred, curriculums: blurredCurriculms };

    // for handling error state
    let errorCurriculms = [
      ...form.errors.curriculums,
      { id: true, year: true, semester_term: true },
    ];
    let newError = { ...form.errors, curriculums: errorCurriculms };

    let newForm = {
      ...form,
      curriculums: curriculums,
      blurred: newBlurred,
      errors: newError,
    };
    setForm(newForm);
  };

  const handleCurriculumRemove = (e, i) => {
    e.preventDefault();
    //remove curriculum data state
    let curriculums = form.curriculums.filter((data, index) => index !== i);

    //remove curriculum blur state
    let blurredCurriculums = form.blurred.curriculums.filter(
      (data, index) => index !== i
    );

    //remove curriculum error state
    let errorCurriculums = form.errors.curriculums.filter(
      (data, index) => index !== i
    );

    let newBlurred = { ...form.blurred, curriculums: blurredCurriculums };
    let newErrors = { ...form.errors, curriculums: errorCurriculums };

    let newForm = {
      ...form,
      curriculums: curriculums,
      blurred: newBlurred,
      errors: newErrors,
    };
    setForm(newForm);
  };

  const handleSubmit = (e) => {
    //handles the submit
    e.preventDefault();

    if (errorExists.fieldError || errorExists.hourError) {
      setForm((prev) => {
        return { ...prev, isSubmitted: true };
      });
    } else {
      let newForm = {
        old_course_code: course.course_code,
        course_name: form.course_name.value,
        course_code: form.course_code.value,
        credit_hr: form.credit_hr.value,
        lecture: form.lecture.value,
        lab: form.lab.value,
        tutorial: form.tutorial.value,
        mentoring: form.mentoring.value,
        advisory: form.advisory.value,
        owner: form.owner.value,
        disabled: 0,
        curriculums: form.curriculums.map((c, index) => {
          return {
            id: courseContext.curriculumState.filter((cur) => {
              console.log(cur.name + "   " + c.id.value);
              return cur.name === c.id.value;
            })[0].id,
            semester_term: c.semester_term.value,
            year: c.year.value,
          };
        }),
      };
      api
        .patch("/course/updateCourse", newForm)
        .then((response) => {
          // alert(JSON.stringify(response, null, 2));
          navigate("../", {
            state: {
              message: { message: "Updated Successfully", type: "success" },
              open: true,
            },
          });
          console.log("updated");
        })
        .catch((err) => {
          // alert(JSON.stringify(err.response, null, 2));
          console.log(JSON.stringify(err.data, null, 2));
          setSnackBarOpen(true);
          setMessage({
            message: err.response.data.message,
            type: "error",
          });
        });
      //console.log(JSON.stringify(form, null, 2));
    }
    //check if the values are set for the required ones
  };
  useEffect(() => {
    checkError();
  }, [form]);

  useEffect(() => {
    api.get("curriculum/curriculums").then((res) => {
      courseContext.curriculumDispatch({
        type: "loadCurriculum",
        curriculums: res.data.curriculums,
      });
    });
    api.get("office/offices").then((res) => {
      officeContext.officeDispatch({
        type: "loadOffice",
        offices: res.data.offices,
      });
    });
  }, []);
  return (
    <Box
      sx={{
        width: "100%",
        //display: "flex",
        //flexDirection: "column",
        //alignItems: "flex-end",
      }}
    >
      <form style={{ width: "100%" }} onSubmit={handleSubmit}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2.5rem",
            padding: "1.3rem",
            borderRadius: "0.5rem",
          }}
        >
          <Box sx={header}>
            <Typography
              variant="span"
              sx={{
                fontSize: "1.4rem",
                fontWeight: "600",
                lineHeight: "23.2px",
                color: "primary.main",
              }}
            >
              Edit Course
            </Typography>

            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              Import
            </Button>
          </Box>
          <Grid container spacing={5} sx={formGroupContainer}>
            <Grid item xs={12} md={5.5} lg={5.5} sx={leftCol}>
              <FormControl sx={groupStyled}>
                <FormLabel sx={labelStyled}>Course Name</FormLabel>
                <TextField
                  name="course_name"
                  value={form.course_name.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    form.isSubmitted &&
                    form.course_name.required &&
                    form.errors.course_name
                  }
                  helperText={
                    form.isSubmitted &&
                    form.course_name.required &&
                    form.errors.course_name &&
                    "Coure name is required"
                  }
                />
              </FormControl>

              <FormControl sx={groupStyled}>
                <FormLabel id="course_code" sx={labelStyled}>
                  Course Code
                </FormLabel>
                <TextField
                  name="course_code"
                  value={form.course_code.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    form.isSubmitted &&
                    form.course_code.required &&
                    form.errors.course_code
                  }
                  helperText={
                    form.isSubmitted &&
                    form.course_code.required &&
                    form.errors.course_code &&
                    "Coure code is required"
                  }
                />
              </FormControl>
              <FormControl sx={groupStyled}>
                <FormLabel htmlFor="owner" sx={labelStyled}>
                  Owner
                </FormLabel>
                <TextField
                  name={`owner`}
                  value={form.owner.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    form.isSubmitted && form.owner.required && form.errors.owner
                  }
                  helperText={
                    form.isSubmitted &&
                    form.owner.required &&
                    form.errors.owner &&
                    "Owner is required"
                  }
                  select
                >
                  {officeContext.officeState
                    .filter((office) => Number(office.status) == 1)
                    .map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                </TextField>
              </FormControl>
              <FormControl sx={groupStyled}>
                <FormLabel id="credit_hr" sx={labelStyled}>
                  Credit Hour
                </FormLabel>
                <TextField
                  name="credit_hr"
                  value={form.credit_hr.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="number"
                  error={
                    form.isSubmitted &&
                    form.credit_hr.required &&
                    form.errors.credit_hr
                  }
                  helperText={
                    form.isSubmitted &&
                    form.credit_hr.required &&
                    form.errors.credit_hr &&
                    "Credit hour is required"
                  }
                  InputProps={{
                    inputProps: { min: 0, max: 20 },
                    endAdornment: (
                      <InputAdornment position="end">Cr Hr</InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={5.5} lg={5.5} sx={col}>
              <Box sx={row}>
                <FormControl sx={groupStyled} fullWidth>
                  <FormLabel sx={labelStyled} htmlFor="lecture">
                    Lecture
                  </FormLabel>
                  <TextField
                    type="number"
                    name="lecture"
                    value={form.lecture.value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      form.isSubmitted &&
                      form.lecture.required &&
                      form.errors.lecture
                    }
                    helperText={
                      form.isSubmitted &&
                      form.lecture.required &&
                      form.errors.lecture &&
                      "Lecture hour is required"
                    }
                    InputProps={{
                      inputProps: { min: 0, max: 20 },
                      endAdornment: (
                        <InputAdornment position="end">Cr Hr</InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
                <FormControl sx={groupStyled} fullWidth>
                  <FormLabel sx={labelStyled} htmlFor="lab">
                    Lab
                  </FormLabel>
                  <TextField
                    type="number"
                    name="lab"
                    value={form.lab.value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      form.isSubmitted && form.lab.required && form.errors.lab
                    }
                    helperText={
                      form.isSubmitted &&
                      form.lab.required &&
                      form.errors.lab &&
                      "Lab hour is required"
                    }
                    InputProps={{
                      inputProps: { min: 0, max: 20 },
                      endAdornment: (
                        <InputAdornment position="end">Cr Hr</InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Box>
              <Box sx={row}>
                <FormControl sx={groupStyled} fullWidth>
                  <FormLabel sx={labelStyled} htmlFor="tutorial">
                    Tutorial
                  </FormLabel>
                  <TextField
                    name="tutorial"
                    type="number"
                    value={form.tutorial.value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      form.isSubmitted &&
                      form.tutorial.required &&
                      form.errors.tutorial
                    }
                    helperText={
                      form.isSubmitted &&
                      form.tutorial.required &&
                      form.errors.tutorial &&
                      "tutorial hour is required"
                    }
                    InputProps={{
                      inputProps: { min: 0, max: 20 },
                      endAdornment: (
                        <InputAdornment position="end">Cr Hr</InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
                <FormControl sx={groupStyled} fullWidth>
                  <FormLabel sx={labelStyled} htmlFor="mentoring">
                    Mentoring
                  </FormLabel>
                  <TextField
                    type="number"
                    name="mentoring"
                    value={form.mentoring.value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      form.isSubmitted &&
                      form.mentoring.required &&
                      form.errors.mentoring
                    }
                    helperText={
                      form.isSubmitted &&
                      form.mentoring.required &&
                      form.errors.mentoring &&
                      "Mentoring hour is required"
                    }
                    InputProps={{
                      inputProps: { min: 0, max: 20 },
                      endAdornment: (
                        <InputAdornment position="end">Cr Hr</InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Box>
              <Box sx={row}>
                <FormControl sx={groupStyled} fullWidth>
                  <FormLabel sx={labelStyled} htmlFor="advisory">
                    Advisory
                  </FormLabel>
                  <TextField
                    name="advisory"
                    type="number"
                    value={form.advisory.value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      form.isSubmitted &&
                      form.advisory.required &&
                      form.errors.advisory
                    }
                    helperText={
                      form.isSubmitted &&
                      form.advisory.required &&
                      form.errors.advisory &&
                      "Advisory hour is required"
                    }
                    InputProps={{
                      inputProps: { min: 0, max: 20 },
                      endAdornment: (
                        <InputAdornment position="end">Cr Hr</InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Box>
              <Box>
                {(errorExists.hourError || errorExists.additionError) &&
                  (errorExists.hourError ? (
                    <Alert
                      severity={
                        form.isSubmitted || errorExists.additionError
                          ? "error"
                          : "warning"
                      }
                      sx={{ width: "100%" }}
                    >
                      One of the hour fields must be filled
                    </Alert>
                  ) : (
                    errorExists.additionError && (
                      <Alert severity={"error"} sx={{ width: "100%" }}>
                        The sum of the hour fields doesn't match with credit
                        Hour
                      </Alert>
                    )
                  ))}
                {/*<CustomizedSnackbars
                    {...{
                      setSnackBarOpen,
                      snackBarOpen: true,
                      message: {
                        message: "One of the hour fields above must be field",
                        type: "danger",
                      },
                    }}
                
                  />*/}
              </Box>
            </Grid>
          </Grid>
          <Divider flexItem />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              borderRadius: "0.5rem",
            }}
          >
            <Box>
              <Typography
                variant="p"
                sx={{ color: "primary", fontWeight: 500 }}
              >
                Curriculum Detail
              </Typography>
            </Box>
            {form.curriculums.map((c, index) => {
              return (
                <Box sx={{ width: "100%", margin: "10px 0px" }} key={index}>
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      ...row,
                      width: "100%",
                    }}
                  >
                    {/*<Box sx={row}>*/}
                    <Grid item xs={12} md={5.5}>
                      <FormControl sx={groupStyled}>
                        <FormLabel htmlFor="curriculum_id" sx={labelStyled}>
                          Curriculum
                        </FormLabel>
                        <Autocomplete
                          id="id"
                          value={c.id.value}
                          onChange={(e, newValue) => {
                            console.log(newValue);
                            handleChange(e, index, "id", newValue);
                            //
                          }}
                          onBlur={(e) => {
                            handleBlur(e, index, "id");
                          }}
                          options={courseContext.curriculumState
                            .map((option) => `${option.name}`)
                            .filter((name) => {
                              return !form.curriculums.reduce(
                                (total, current) => {
                                  return total || current.id.value === name;
                                },
                                false
                              );
                            })}
                          renderInput={(params) => (
                            <TextField
                              name="id"
                              {...params}
                              error={
                                form.isSubmitted &&
                                form.curriculums[index].id.required &&
                                form.errors.curriculums[index].id
                              }
                              helperText={
                                form.isSubmitted &&
                                form.curriculums[index].id.required &&
                                form.errors.curriculums[index].id &&
                                "Curriculum is required"
                              }
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item={12} md={5.5} sx={row}>
                      <FormControl sx={groupStyled}>
                        <FormLabel htmlFor="semester_term" sx={labelStyled}>
                          Semester
                        </FormLabel>
                        <TextField
                          name={`semester_term`}
                          value={c.semester_term.value}
                          onChange={(e) => {
                            handleChange(e, index);
                          }}
                          onBlur={(e) => {
                            handleBlur(e, index);
                          }}
                          select
                          error={
                            form.isSubmitted &&
                            form.curriculums[index].semester_term.required &&
                            form.errors.curriculums[index].semester_term
                          }
                          helperText={
                            form.isSubmitted &&
                            form.curriculums[index].semester_term.required &&
                            form.errors.curriculums[index].semester_term &&
                            "Semester is required"
                          }
                        >
                          {semester.map((option) => (
                            <MenuItem key={option.name} value={option.value}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                      <FormControl sx={groupStyled}>
                        <FormLabel htmlFor="year" sx={labelStyled}>
                          Year
                        </FormLabel>
                        <TextField
                          id={`year`}
                          name={`year`}
                          value={c.year.value}
                          onChange={(e) => {
                            handleChange(e, index);
                          }}
                          onBlur={(e) => {
                            handleBlur(e, index);
                          }}
                          select
                          error={
                            form.isSubmitted &&
                            form.curriculums[index].year.required &&
                            form.errors.curriculums[index].year
                          }
                          helperText={
                            form.isSubmitted &&
                            form.curriculums[index].year.required &&
                            form.errors.curriculums[index].year &&
                            "Year is required"
                          }
                        >
                          {year.map((option) => (
                            <MenuItem key={option.name} value={option.value}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                      <Box>
                        <Tooltip
                          title="Remove"
                          placement="top-end"
                          onClick={(e) => {
                            handleCurriculumRemove(e, index);
                          }}
                        >
                          <IconButton>
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Grid>

                    {/*</Box>*/}
                  </Grid>
                </Box>
              );
            })}
          </Box>
          <Box width={1} sx={{ display: "flex", justifyContent: "center" }}>
            <Tooltip title="Add curriculum" onClick={handleAddCurriculum}>
              <IconButton>
                <AddIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <CustomizedSnackbars
            {...{ setSnackBarOpen, snackBarOpen, message }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "1.8rem",
            justifyContent: "flex-end",
            width: "100%",
            padding: "0 0 1.7rem 1.7rem",
          }}
        >
          <Button
            variant="outlined"
            color="third"
            onClick={() => navigate("../")}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "secondary.main",
              "&:hover": {
                backgroundColor: "secondary.hover",
              },
            }}
            type="submit"
            disabled={
              errorExists.additionError ||
              errorExists.fieldError ||
              errorExists.hourError
            }
          >
            Update
          </Button>
        </Box>
      </form>
      <Dialog open={open}>
        <ImportModal close={{ setOpen: setOpen }} />
      </Dialog>
    </Box>
  );
}

export default EditCourse;
